module.exports = __webpack_public_path__ + "img/worksbot_img19122401.a87da004.jpg";